import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import './IncompleteSubitemsWarningModal.css';
import { useTrackModal } from '../../hooks/useTrackModal';

const IncompleteSubitemsWarningModal = ({ 
  isOpen, 
  onClose, 
  onOverride, 
  incompleteSubitems = [] 
}) => {
  useTrackModal("IncompleteSubitemsWarningModal", isOpen);
  if (!isOpen) return null;

  return (
    <div className="warning-modal-overlay" onClick={onClose}>
      <div className="warning-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="warning-modal-header critical">
          <div className="warning-modal-title">
            <AlertTriangle size={24} className="warning-icon" />
            <h2>Critical: Incomplete Subitems</h2>
          </div>
          <button className="warning-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="warning-modal-body">
          <div className="warning-message">
            <p className="warning-text">
              <strong>WARNING:</strong> You are attempting to send an export with {incompleteSubitems.length} incomplete subitem{incompleteSubitems.length > 1 ? 's' : ''}.
            </p>
            <p className="warning-subtext">
              All subitems should have a status (including N/A) before sending. Sending with incomplete subitems may result in missing or incorrect data.
            </p>
          </div>

          <div className="incomplete-subitems-list">
            <h3>Incomplete Subitems:</h3>
            <div className="subitems-scroll">
              {incompleteSubitems.map((subitem, index) => (
                <div key={subitem.id} className="incomplete-subitem">
                  <span className="subitem-number">{index + 1}.</span>
                  <div className="subitem-details">
                    <span className="subitem-name">{subitem.name}</span>
                    <span className="subitem-stage">Stage: {subitem.phase || 'Unknown'}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="warning-question">
            <p>Are you absolutely sure you want to proceed without completing these subitems?</p>
          </div>
        </div>

        <div className="warning-modal-footer">
          <button className="warning-cancel-btn" onClick={onClose}>
            Cancel & Complete Subitems
          </button>
          <button className="warning-override-btn" onClick={onOverride}>
            <AlertTriangle size={16} />
            Override & Send Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncompleteSubitemsWarningModal;